import { Skeleton } from '@mui/material';
import React from 'react'
import styled from 'styled-components'

export default function ProfileStatsCard(props){
	const { 
        kpisLoaded = false,
        kpiItems = [],
        items = []
	} = props

	return (
		<Wrapper 
            className={"card border-none bg-light p-0 text-gc-dark-blue h-100"}
        >
            { !kpisLoaded ? (
                <Skeleton 
                    className="card bg-light border-none" 
                    variant="rectangular" 
                    width="100%" 
                    height={95} 
                />
            ) : (
                <div className={"h-100 align-items-center p-4 d-flex flex-wrap " + ((items.length + kpiItems.length) > 1 ? "justify-content-between" : "justify-content-around")}>
                    { kpiItems.length !== 0 && (
                        kpiItems.length > 1 ? (
                            <div className={"kpi-list flex-fill flex-wrap py-1 " + (items.length > 0 && "pr-3 mr-3")}>
                                {
                                    kpiItems.map((e, i) =>
                                        <div 
                                            key={i}
                                            className="d-flex justify-content-between align-items-center text-left"
                                        >
                                            {
                                                (e.items).map((ee, ii) =>
                                                    <div key={ii}>
                                                        <i className={ee.iconClass + " h6 mr-1"}></i>
                                                        <span className="font-weight-bold">{ee.value} </span>
                                                        <span className="small font-weight-normal">{(ee.text).trad()}</span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                            </div>
                        ) : (
                            kpiItems[0].items).map((e, i) => (
                                <div 
                                    key={i} 
                                    className="d-flex align-items-center text-left"
                                >
                                    <div className="h4 pt-2 pr-2">
                                        <i className={e.iconClass}></i>
                                    </div>
                                    <div>
                                        <span className="d-block h5 font-weight-bold m-0">
                                            {e.value}
                                        </span>
                                        <span className="d-block small font-weight-normal" style={{marginTop: '-5px'}}>
                                            {e.text}
                                        </span>
                                    </div>
                                </div>
                            )
                        )
                    )}

                    { items.map((e, i) => (
                        <div 
                            key={i} 
                            className="d-flex align-items-center text-left"
                        >
                            <div className="h4 pt-2 pr-2">
                                {e.icon}
                            </div>
                            <div>
                                <span className="d-block h5 font-weight-bold m-0">
                                    {e.number}
                                </span>
                                <span className="d-block small font-weight-normal" style={{marginTop: '-5px'}}>
                                    {e.text}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
		</Wrapper>
	);
}

const Wrapper = styled.div`
    &.card {
        min-height: 80px;
    }
    .small {
        font-size: .8rem;
        margin-top: -5px;
    }

    .kpi-list {
        min-height: 70px;
        overflow-y: auto;
        overflow-x: hidden!important;

        /* width */
        &::-webkit-scrollbar {
            background-color: transparent;
            width: 5px;
        }
        
        /* Track */
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
        
        /* Handle */
        &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.2);
            border-radius: 10px;
        }
    }
`